import * as React from 'react';
import Heading from '../../../components/heading/Heading';
import { Icon as IconObject } from '../../../core/constants/Icon';
import Icon from '../../../components/icon/Icon';

type IconName = keyof typeof IconObject;

const IconsStyleGuide: React.FC<any> = () => (
  <>
    <hr />
    <Heading size="h2">Icons</Heading>
    <hr />
    <table className="table" style={{ width: '50%', border: '1px solid rgba(198, 198, 198, 0.5)' }}>
      <thead>
        <tr style={{ height: '50px', borderBottom: '2px solid rgba(198, 198, 198, 0.5)' }}>
          <th>Icon name</th>
          <th>Icon</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(IconObject).map((item) => {
          const iconName = item as IconName;
          return (
            <tr key={iconName} style={{ height: '40px', borderBottom: '1px solid rgba(198, 198, 198, 0.5)' }}>
              <td style={{ width: '50%' }}>{item}</td>
              <td>
                <Icon icon={iconName} svg />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>

    <hr />
  </>
);

export default IconsStyleGuide;
